/*
  Shared custom-dropdown wrapper for the YMM Make/Model/Year selects (used by
  both sections/ymm-filters.liquid and snippets/ymm-fitment-check.liquid).

  Deliberately does NOT replace how selection state is tracked: the native
  <select> stays in the DOM as the real source of truth (visually hidden,
  removed from tab order), and every existing bit of buildTree/populateModels/
  populateYearRanges/fillSelect logic keeps writing to it exactly as before --
  this module only adds a styled trigger + dropdown list on top that mirrors
  it, via a MutationObserver watching for option-list/disabled changes, and
  writes back through nativeSelect.value + a real dispatched 'change' event so
  every existing addEventListener('change', ...) handler keeps firing
  unchanged. Nothing that already reads/writes these <select>s needed to
  change to get the new look.
*/
(function(){
  function closeAll(except){
    document.querySelectorAll('.ymm-custom-select__list:not([hidden])').forEach(function(list){
      if (list !== except) {
        list.hidden = true;
        var wrap = list.closest('.ymm-custom-select');
        if (wrap) wrap.classList.remove('ymm-custom-select--open');
      }
    });
  }
  document.addEventListener('click', function(){ closeAll(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(); });

  function enhance(nativeSelect){
    if (!nativeSelect) return null;
    if (nativeSelect._ymmEnhanced) return nativeSelect._ymmEnhanced;

    var wrap = document.createElement('div');
    wrap.className = 'ymm-custom-select';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ymm-custom-select__trigger';

    var list = document.createElement('ul');
    list.className = 'ymm-custom-select__list';
    list.hidden = true;

    nativeSelect.insertAdjacentElement('afterend', wrap);
    wrap.appendChild(trigger);
    wrap.appendChild(list);
    nativeSelect.classList.add('ymm-custom-select__native');
    nativeSelect.tabIndex = -1; // the trigger button is the real interactive control now

    function sync(){
      var opts = Array.prototype.slice.call(nativeSelect.options);
      var current = opts.filter(function(o){ return o.value === nativeSelect.value; })[0] || opts[0];
      trigger.textContent = current ? current.textContent : '';
      trigger.disabled = nativeSelect.disabled;
      wrap.classList.toggle('ymm-custom-select--disabled', nativeSelect.disabled);

      list.innerHTML = '';
      opts.forEach(function(o){
        var li = document.createElement('li');
        li.className = 'ymm-custom-select__option';
        li.textContent = o.textContent;
        li.setAttribute('role', 'option');
        if (o.value === nativeSelect.value) li.setAttribute('aria-selected', 'true');
        li.addEventListener('click', function(e){
          e.stopPropagation();
          if (nativeSelect.value !== o.value) {
            nativeSelect.value = o.value;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
          list.hidden = true;
          wrap.classList.remove('ymm-custom-select--open');
        });
        list.appendChild(li);
      });
    }

    trigger.addEventListener('click', function(e){
      e.stopPropagation();
      if (nativeSelect.disabled) return;
      var willOpen = list.hidden;
      closeAll(willOpen ? list : null);
      list.hidden = !willOpen;
      wrap.classList.toggle('ymm-custom-select--open', willOpen);
    });

    nativeSelect.addEventListener('change', sync);
    new MutationObserver(sync).observe(nativeSelect, {
      childList: true, attributes: true, attributeFilter: ['disabled']
    });

    sync();
    nativeSelect._ymmEnhanced = { sync: sync, wrap: wrap };
    return nativeSelect._ymmEnhanced;
  }

  window.YmmCustomSelect = { enhance: enhance };
})();
